import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ReportList } from 'src/app/Modules/informate/models/reports/data-sheet-report.model';
import { AppConstants } from 'src/app/constants/appconstants';
import { UserUtilityService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { ManagementApiService } from 'src/app/services/management-api.service';

@Component({
    selector: 'app-instance-reports',
    templateUrl: './instance-reports.component.html',
    styleUrls: ['./instance-reports.component.scss'],
    standalone: false
})
export class InstanceReportsComponent implements OnInit, OnDestroy {
    @Input() currentTab: number;
    destroy$ = new Subject();

    reportList: ReportList[];
    reportListCopy: ReportList[];
    defaultReport: ReportList[];
    customReport: ReportList[];
    instanceId: string;

    constructor(
        private ngxUiLoaderService: NgxUiLoaderService,
        private mgmtApi: ManagementApiService,
        private cd: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private mngmtApi: ManagementApiService,
        private instanceDataService: InstanceDataService,
        private user_utlity: UserUtilityService,
        private customToastService: CustomToastService
    ) {}

    ngOnInit(): void {
        this.handleSubscription();
    }

    handleSubscription() {
        this.instanceDataService.instanceActiveTab.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_reports) {
                if (this.activatedRoute.snapshot.paramMap.get('id')) {
                    this.instanceId = this.activatedRoute.snapshot.paramMap.get('id');
                    this.getReportListByInstance();
                } else {
                    this.instanceId = this.instanceDataService.instanceDetails.instanceId;
                    this.getreporttemplates();
                }
            }
        });

        this.instanceDataService.instanceTabNext.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_reports) {
                this.nextButtonClick();
            }
        });

        this.instanceDataService.instanceTabBack.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_reports) {
                this.instanceDataService.instanceNavigationHandler(15);
            }
        });
    }

    async getreporttemplates() {
        try {
            if (!this.reportList?.length) {
                this.ngxUiLoaderService.start();
                let result = await this.mgmtApi.getreporttemplates().toPromise();

                if (result.response) {
                    this.reportList = result.response;
                    this.defaultReport = result?.response.filter((m) => m.isCustom == false);
                    this.customReport = result.response.filter((m) => m.isCustom == true);
                    this.ngxUiLoaderService.stop();
                } else {
                    this.ngxUiLoaderService.stop();
                    this.user_utlity.errorModelPopup(result.message);
                }

                this.cd.detectChanges();
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    async getReportListByInstance() {
        try {
            if (!this.reportListCopy?.length) {
                this.ngxUiLoaderService.start();
                let result = await this.mgmtApi.getReportListByInstance(this.instanceId).toPromise();

                if (result.success) {
                    if (result.response.length) {
                        this.reportListCopy = result.response;
                        this.reportList = result.response;
                        this.defaultReport = result.response.filter((m) => m.isCustom == false);
                        this.customReport = result.response.filter((m) => m.isCustom == true);
                    } else {
                        await this.getreporttemplates();
                    }

                    this.ngxUiLoaderService.stop();
                    this.cd.detectChanges();
                } else {
                    this.ngxUiLoaderService.stop();
                    this.user_utlity.errorModelPopup(result.message);
                }
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    isreportCheckedHandler(item: any) {
        let index = this.reportList.findIndex((type) => type.name == item.data.name);
        if (index !== -1) {
            this.reportList[index].isSelected = item.checked;
        }
    }

    nextButtonClick() {
        if (this.reportList?.length) {
            this.ngxUiLoaderService.start();
            if (this.activatedRoute.snapshot.paramMap.get('id')) {
                this.mngmtApi.putInstancereports(this.reportList, this.instanceId).subscribe(
                    (response) => {
                        if (response) {
                            this.customToastService.successToast('Saved successfully', 'Success');
                            this.instanceDataService.instanceNavigationHandler(14);
                        } else {
                            this.user_utlity.errorModelPopup(response.message);
                        }
                        this.ngxUiLoaderService.stop();
                    },
                    (error) => {
                        this.ngxUiLoaderService.stop();
                    }
                );
            } else {
                this.mngmtApi.postInstancereports(this.reportList, this.instanceId).subscribe(
                    (response) => {
                        if (response) {
                            this.customToastService.successToast('Saved successfully', 'Success');
                            this.instanceDataService.instanceNavigationHandler(14);
                        } else {
                            this.user_utlity.errorModelPopup(response.message);
                        }
                        this.ngxUiLoaderService.stop();
                    },
                    (error) => {
                        this.ngxUiLoaderService.stop();
                    }
                );
            }
        } else {
            this.instanceDataService.instanceNavigationHandler(14);
        }
    }

    navigateBack() {
        this.instanceDataService.instanceNavigationHandler(15);
    }

    ngOnDestroy() {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
